import { render, staticRenderFns } from "./index.vue?vue&type=template&id=734aacd4&scoped=true&lang=pug"
import script from "./script.ts?vue&type=script&lang=js&external"
export * from "./script.ts?vue&type=script&lang=js&external"
import style0 from "./index.vue?vue&type=style&index=0&id=734aacd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734aacd4",
  null
  
)

export default component.exports